import i18n from '../localization/i18n.ts';
import {createFileRoute, notFound, redirect} from '@tanstack/react-router';
import {getFirstSlug} from '@area-monitoring/am-app-manual';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const slug = getFirstSlug(i18n.language);
    if (!slug) {
      throw notFound();
    }
    throw redirect({to: '/$slug', params: {slug}});
  },
});
